import { cn } from "@/lib/utils";
import type { SettingsSection } from "../../types";

interface SectionCardProps {
  section: SettingsSection;
  isActive: boolean;
  onClick: () => void;
}

export function SectionCard({ section, isActive, onClick }: SectionCardProps) {
  const Icon = section.icon;

  return (
    <button
      type="button"
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
      className={cn(
        "w-full flex items-center space-x-3 px-3 py-2 rounded-lg text-left transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
        isActive
          ? "bg-indigo-50 text-indigo-700 border border-indigo-200 dark:bg-indigo-950/50 dark:text-indigo-300 dark:border-indigo-800"
          : "text-gray-700 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-gray-800"
      )}
      role="menuitem"
      aria-current={isActive ? "page" : undefined}
    >
      <Icon className="w-5 h-5 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="font-medium text-sm">{section.title}</div>
      </div>
    </button>
  );
}
